import { useEffect } from 'react';
import { useAppDispatch } from 'App/store';
import useCheckBackgroundJobs from './useCheckBackgroundJobs';
import { getJobsAction } from '../../jobsSlice';

function BackgroundDispatcher() {
  const dispatch = useAppDispatch();

  useCheckBackgroundJobs('productsCsvDownload');
  useCheckBackgroundJobs('editPricesProducts');
  useCheckBackgroundJobs('customerCsvDownload');
  useCheckBackgroundJobs('ordersCsvDownload');
  useCheckBackgroundJobs('assignCategories');
  useCheckBackgroundJobs('productsCsvImport');
  useCheckBackgroundJobs('customersCsvImport');
  useCheckBackgroundJobs('deleteLocation');

  useEffect(() => {
    dispatch(getJobsAction('backgroundJobs'));
  }, [dispatch]);

  return null;
}

export default BackgroundDispatcher;
